
define('text!libs/strand/src/strand-template-finder/template.html',[],function () { return '<template id="import">\n\t<div>passed as import <span>{{obj.field}}</span></div>\n</template>\n';});

